class ChileRUT {
  validate(rut: string | null | undefined): boolean {
    if (!rut) return false;

    rut = rut.replace(/\./g, '').replace('-', '');

    if (!/^[0-9]{7,8}[0-9Kk]$/.test(rut)) return false;

    const body = rut.slice(0, -1);
    const checkDigit = rut.slice(-1).toUpperCase();

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body.charAt(i)) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const expectedCheckDigit = 11 - (sum % 11);
    const calculatedCheckDigit =
      expectedCheckDigit === 11
        ? '0'
        : expectedCheckDigit === 10
        ? 'K'
        : expectedCheckDigit.toString();

    return calculatedCheckDigit === checkDigit;
  }
}

export const ChileRUTValidator = new ChileRUT();
